module.exports = __webpack_public_path__ + "static/media/Mariah Carey - All I Want for Christmas Is You (Make My Wish Come True Edition).e114b136.mp3";